import { Controller } from "@hotwired/stimulus"

// Context switcher dropdown in course operator portal (depth 1 + 2 headers).
export default class extends Controller {
  static targets = ["panel", "trigger", "caret"]

  connect() {
    this.boundTurboVisit = () => this.close()
    document.addEventListener("turbo:before-visit", this.boundTurboVisit)
    document.addEventListener("click", this.boundDocumentClick = this.documentClick.bind(this))
    document.addEventListener("keydown", this.boundKeydown = this.keydown.bind(this))
    this.close()
  }

  disconnect() {
    this.syncPageCardVisibility(false)
    document.removeEventListener("turbo:before-visit", this.boundTurboVisit)
    document.removeEventListener("click", this.boundDocumentClick)
    document.removeEventListener("keydown", this.boundKeydown)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    if (this.isOpen()) {
      this.close()
    } else {
      this.open()
    }
  }

  isOpen() {
    return this.hasPanelTarget && !this.panelTarget.hidden
  }

  open() {
    this.panelTarget.hidden = false
    if (this.hasTriggerTarget) {
      this.triggerTarget.setAttribute("aria-expanded", "true")
    }
    if (this.hasCaretTarget) {
      this.caretTarget.textContent = "expand_less"
    }
    this.syncPageCardVisibility(true)
  }

  close() {
    if (this.hasPanelTarget) {
      this.panelTarget.hidden = true
      if (this.hasTriggerTarget) {
        this.triggerTarget.setAttribute("aria-expanded", "false")
      }
      if (this.hasCaretTarget) {
        this.caretTarget.textContent = "expand_more"
      }
    }
    this.syncPageCardVisibility(false)
  }

  syncPageCardVisibility(isOpen) {
    const main = this.element.closest(".courses-portal-main")
    if (main) {
      main.classList.toggle("courses-portal-main--context-panel-open", isOpen)
    }
  }

  documentClick(event) {
    if (!this.isOpen()) {
      return
    }

    if (this.element.contains(event.target)) {
      return
    }

    this.close()
  }

  keydown(event) {
    if (event.key !== "Escape" || !this.isOpen()) {
      return
    }

    this.close()
    if (this.hasTriggerTarget) {
      this.triggerTarget.focus()
    }
  }
}
